
<div class="columns is-vcentered">
    <div class="column is-two-fifths" style="text-align: right;">
        <img src="assets/version2/signup-banner.jpg" alt="">
    </div>
    <div class="column">
    <div class="title">{{'LblIylonConnectPayment' | translate}}</div>
    <div class="subHeading title is-2" style="color: #232323; font-size: 25px;">
        Hello {{details.Salutation}}. {{details.FirstName}}  {{details.LastName}} , <br> <br>
       <label style="font-size: 20px;"> Thankyou For Showing Interest in Iylon Connect. <br>
        Please Click on below "Pay Now" button  and proceed with your payment of ${{details.Amount}}</label>
    </div>
    <button class="section-header button transparent-button" (click)="pay()"> Pay Now </button> 
</div>
</div>

